module.exports = __webpack_public_path__ + "static/Plasmoid_Ontalak-2372d90800827458c5c0c51eb79db0cf.webp";